import AccountModel from "../Account/AccountModel";

/* This is a helper class that will let us pull values
from the member object in the state without them being a mile long
*/
export class Member {
  static hasSeenStartShiftModal: boolean = false;

  static get account() {
    return AccountModel.state.account;
  }

  static get id() {
    return AccountModel.state.member?.id;
  }

  static get jwt() {
    return (AccountModel.state.member as any)?.jwt;
  }

  static get member() {
    return AccountModel.state.member;
  }

  static get displayName() {
    return AccountModel.state.member?.agentName || AccountModel.state.account?.firstName || "Agent";
  }
  static get avatarURL() {
    return (
      AccountModel.state.member?.agentAvatarURL ||
      AccountModel.state.account?.avatarURL ||
      "https://swivl-cdn.s3-us-west-1.amazonaws.com/studio/member-avatar-blank.png"
    );
  }

  static get org() {
    return AccountModel.state.member?.org;
  }

  static get orgId() {
    return AccountModel.state.member!.org.id;
  }

  static get isInParentOrg() {
    return AccountModel.state.member?.org.isParent;
  }

  static get isInChildOrg() {
    return AccountModel.state.member?.org.parentId !== null;
  }

  static _canSeeOrg: { loaded: boolean; canSee: boolean } = { loaded: false, canSee: false };

  static get canSeeOrgSettings() {
    if (this._canSeeOrg.loaded) {
      return this._canSeeOrg.canSee;
    }
    this._canSeeOrg.loaded = true;
    this._canSeeOrg.canSee =
      AccountModel.state.member?.permissions.find((p) => {
        if (p.locations.orgId) {
          return true;
        }
      }) !== undefined;
    return this._canSeeOrg.canSee;
  }

  static get isSuperAdmin() {
    return AccountModel.state.member?.swivlAdmin ? true : false;
  }

  static get isDev() {
    return AccountModel.state.account?.id === 1 ? true : false;
  }

  static get twilioToken() {
    return AccountModel.state.member?.twilioToken;
  }

  static updateLastActive() {
    if (AccountModel.state.member && AccountModel.state.accountLoaded) {
    }
  }
}
